module.exports = __webpack_public_path__ + "static/media/icon_arrow_up.32b410d3.svg";